import React, { useEffect, useState } from "react";
import { CircularProgress, Stack } from "@mui/material";
import useStyles from "./styles";
import { color } from "../../../config/theme";
import { getApiData } from "../../../utils/APIHelper";
import { Setting } from "../../../utils/Setting";
import ChangeRequestList from "./components/ChangeRequestList";
import { useSearchParams } from "react-router-dom";
import ChangeRequestTabs from "./components/ChangeRequestTabs";

const Changelog = ({ projectId ,projectDetails}) => {
  const [changelogs, setChangelogs] = useState([]);
  const [loading, setLoading] = useState();
  const classes = useStyles();
  let [searchParams, setSearchParams] = useSearchParams();

  const changeId = searchParams.get("change");

  const getChangelogItems = async () => {
    try {
      setLoading(true);
      const data = await getApiData(
        Setting.endpoints.changeRequest.list(projectId),
        "GET",
        {},
        {},
        true
      );
      setChangelogs(data);
      console.log(data, "ccc")
    } catch (error) {
      console.log("error in change log list", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (projectId) {
      getChangelogItems();
    }
  }, [projectId]);

  const refetch = () => {
    getChangelogItems()
  }

  return (
    <Stack className={classes.groupContainer}>
      {loading !== false ? (
        <div className={classes.loadingContainer}>
          <CircularProgress style={{ color: color.primary }} />
        </div>
      ) : changelogs && changelogs?.length === 0 ? (
        <center style={{ padding: "2vmax" }}>No change request found</center>
      ) : (
        <>
          {/* {changelogs?.map((changelog) => (
          <ChangeRequestItem
            key={changelog?.changeRequest?.changeRequestId}
            changelog={changelog}
          />
        ))} */}
          {changeId && changeId !== "" ? (
            <ChangeRequestTabs changeId={changeId} projectDetails={projectDetails}/>
          ) : (
            <ChangeRequestList list={changelogs} refetch={refetch} projectDetails={projectDetails}/>
          )}
        </>
      )}
    </Stack>
  );
};

export default Changelog;
